// components/doctors/Appointments/AppointmentCard.jsx
import React from 'react';
import { format, isToday, isTomorrow } from 'date-fns';
import '../../../styles/components/doctor/AppointmentCard.css';

import calendarIcon from '../../../assets/logo/date_icon.svg';
import clockIcon from '../../../assets/logo/clock_icon.svg';
import typeIcon from '../../../assets/logo/call_icon.svg';


const AppointmentCard = ({ appointment, onJoin, onViewPatient, className = '' }) => {
  // Extract patient info with fallbacks for incomplete data

  console.log('Raw appointment date string in card:', appointment.appointmentDate);

  const patientName = appointment.patient ? 
    `${appointment.patient.firstName || ''} ${appointment.patient.lastName || ''}`.trim() : 
    'Unknown Patient';
  
  // Format appointment date/time
  const formatAppointmentDate = (dateString) => {
    if (!dateString) return 'Date TBD';
    
    try {
      const appointmentDate = new Date(dateString);
      
      // Day display logic
      let dayDisplay;
      if (isToday(appointmentDate)) {
        dayDisplay = 'Today';
      } else if (isTomorrow(appointmentDate)) {
        dayDisplay = 'Tomorrow';
      } else {
        dayDisplay = format(appointmentDate, 'MMMM dd, yyyy');
      }
      
      return dayDisplay;
    } catch (error) {
      console.error('Error formatting appointment date:', error);
      return dateString;
    }
  };
  
  // Format time
  const formatTime = (dateString) => {
    if (!dateString) return 'Time TBD';
    
    try {
      // Extract time directly from ISO string to avoid timezone conversion
      const match = dateString.match(/T(\d{2}):(\d{2})/);
      
      if (!match) return 'Invalid time';
      
      const hours = parseInt(match[1]);
      const minutes = match[2];
      
      // Format to 12-hour time with AM/PM
      const ampm = hours >= 12 ? 'PM' : 'AM';
      const hour12 = hours % 12 || 12; // Convert 0 to 12
      
      return `${hour12}:${minutes} ${ampm}`;
    } catch (error) {
      console.error('Error formatting appointment time:', error);
      return 'Invalid time';
    }
  };
  
  // Determine appointment type
  const appointmentType = appointment.appointmentType || 'Consultation';
  const isTeleconsult = appointmentType.toLowerCase().includes('tele') || 
                        appointment.meetingType || 
                        appointment.meetingLink;
  
  const appointmentTypeDisplay = isTeleconsult ? 
    `Online, Voice / Video Call` : 
    appointmentType;
  
  return (
    <div className={`appt-card-unique ${className}`}>
      <div className="appt-card-unique__header">
        <h3 className="appt-card-unique__title">Upcoming Appointment</h3>
      </div>
      
      <div className="appt-card-unique__content">
        <div className="appt-card-unique__patient-section">
          <div className="appt-card-unique__patient-avatar">
            {appointment.patient?.profilePicture && appointment.patient.profilePicture !== 'default-profile.png' ? (
              <img 
                src={appointment.patient.profilePicture} 
                alt="Patient Profile" 
                className="appt-card-unique__profile-image"
              />
            ) : (
              <div className="appt-card-unique__default-avatar">
                {patientName.charAt(0)}
              </div>
            )}
          </div>
          <div className="appt-card-unique__patient-info">
            <h4 className="appt-card-unique__patient-name">{patientName}</h4>
            <button 
              className="appt-card-unique__view-patient-btn"
              onClick={() => onViewPatient(appointment.patient?._id)}
            >
              View Patient
            </button>
          </div>
          {isTeleconsult && appointment.meetingLink && (
            <button 
              className="appt-card-unique__join-btn" 
              onClick={() => onJoin(appointment)}
            >
              Join
            </button>
          )}
        </div>
        
        <div className="appt-card-unique__details-grid">
  <div className="appt-card-unique__detail-box">
    <div className="appt-card-unique__detail-icon">
      <img src={calendarIcon} alt="Calendar" className="appt-card-unique__icon-img" />
    </div>
    <div className="appt-card-unique__detail-text">
      {formatAppointmentDate(appointment.appointmentDate)}
    </div>
  </div>
  
  <div className="appt-card-unique__detail-box">
    <div className="appt-card-unique__detail-icon">
      <img src={clockIcon} alt="Clock" className="appt-card-unique__icon-img" />
    </div>
    <div className="appt-card-unique__detail-text">
      {formatTime(appointment.appointmentDate)}
    </div>
  </div>
  
  <div className="appt-card-unique__detail-box">
    <div className="appt-card-unique__detail-icon">
      <img src={typeIcon} alt="Type" className="appt-card-unique__icon-img" />
    </div>
    <div className="appt-card-unique__detail-text">
      {appointmentTypeDisplay}
    </div>
  </div>
</div>
      </div>
    </div>
  );
};

export default AppointmentCard;